module.exports = __webpack_public_path__ + "static/img/0.6676448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nationalDay/card/0.png
// module id = aKT8
// module chunks = 2